import {createContext} from 'react';
import {
    AuthUser,
    JWT
} from 'aws-amplify/auth';


type AuthContextType = {
    user: AuthUser | null,
    idToken?: JWT | null,
    accessToken?: JWT | null,
    cognitoGroups?: string[] | null,
}


export const AuthContext = createContext<AuthContextType>({
                                                              user: null,
                                                              idToken: null,
                                                              accessToken: null,
                                                              cognitoGroups: null,
                                                          });

